export const TabelBooleanText = ({ value = false }) => {
  return (
    <label className="inline-flex items-center">
      <label
        className={`relative w-11 h-6 bg-greyText rounded-full  ${
          value ? "bg-primary" : ""
        }`}
      >
        <label
          className={`absolute top-[2px] ${
            value ? "start-[calc(100%-22px)]" : "start-[2px]"
          } h-5 w-5 rounded-full transition-all bg-white`}
        />
      </label>
    </label>
  );
};

export const TabelArrayText = ({ arrayData = [] }) => {
  return (
    <span className="capitalize">
      {arrayData?.length > 0
        ? arrayData?.map((ele, index) => {
            return (
              <span key={index}>
                <span className="text-greyText">{index ? " | " : ""}</span>
                {ele ? ele : "--"}
              </span>
            );
          })
        : "--"}
    </span>
  );
};

export const TabelImage = ({ url }) => {
  return (
    <span>
      <img src={url} alt="image" className="w-[4rem] h-[4rem] rounded-md" />
    </span>
  );
};
